/**
 * Module definition for users module. The users module manages
 * the application's top-level users view (i.e., /users).
 *
 * @module routes.users
 */

angular.module('routes.users', [
  'routes.users.constants',
  'routes.users.UsersController',
  'routes.users.UsersPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.users', {
          url: '/users/:userId',
          templateUrl: 'routes/users/users.html',
          controller: 'UsersController',
          params: {
            userId: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'USERS',
              function (ConstantResolver, USERS) {
                return new ConstantResolver(USERS);
              }
            ],
            usersPayload: [
              'UsersPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (UsersPayloadResolver, $stateParams, newmanPayload) {
                return new UsersPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
